import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { z } from 'zod'

import { Button } from '@/components/ui/button'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import API from '@/lib/api'
import { AdminAccountDetail } from '@/types/Account'

const schema = z.object({
  maxVariantAxes: z.coerce.number().int().min(1),
})

type AdminAccountMaxVariantAxesFormData = z.infer<typeof schema>

export function AdminAccountMaxVariantAxesForm({
  accountId,
  maxVariantAxes,
  onSuccess,
}: {
  accountId: string
  maxVariantAxes: number
  onSuccess: (account: AdminAccountDetail) => void
}) {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'admin.accounts.detail.maxVariantAxes',
  })
  const { t: tg } = useTranslation(undefined, {
    keyPrefix: 'generic',
  })

  const form = useForm<AdminAccountMaxVariantAxesFormData>({
    resolver: zodResolver(schema),
    defaultValues: { maxVariantAxes },
  })

  const onSubmit = (data: AdminAccountMaxVariantAxesFormData) => {
    API.patch<AdminAccountDetail>(`/api/v2/admin/accounts/${accountId}`, data)
      .then((response) => {
        toast.success(t('success'))
        onSuccess(response.data)
      })
      .catch(() => {
        toast.error(t('error'))
      })
  }

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="flex items-end gap-3">
        <FormField
          control={form.control}
          name="maxVariantAxes"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t('label')}</FormLabel>
              <FormControl>
                <Input type="number" min={1} className="w-32" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <Button type="submit">{tg('button.save')}</Button>
      </form>
    </Form>
  )
}
